export default __webpack_public_path__ + "static/media/spendCategoryMoneyTransfer32.a336f9ed.svg";